/**
* @author ZhanFuzheng
* @date 2022/07/14
* @time 16:13
* @update 2022/09/05 ZhanFuzheng 灯光仿真页面 新增 支付流程
* @update 2023/04/26 ZhanFuzheng 新增轮播突破
*/
<template>
    <div>
        <div id="wrapper">
            <div class="detail">
                <div class="swiper-image">
                    <img class="detail-image" src="@/assets/vipGoods/106/picture_ksdgmn2.png"/>

                    <swiper class="swiper" ref="swiper" :options="swiperOptions">
                        <swiper-slide v-for="(imagePath, index) in carItems" :key="index">
                            <div class="swiper-item">
                                <img class="item-img" :src="imagePath"/>
                            </div>
                        </swiper-slide>
                    </swiper>
                </div>
                <div class="loop-image">
                    <img class="detail-image" src="@/assets/vipGoods/106/picture_ksdgmn.png"/>

                    <van-swipe class="my-swipe" :autoplay="5000" indicator-color="white">
                        <van-swipe-item v-for="(item, index) in loopImages" :key="index" @click="preview(index)"><img
                            class="detail-image" :src="item"/></van-swipe-item>
                    </van-swipe>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { Swipe, SwipeItem, ImagePreview } from 'vant'
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'

export default {
    name: 'goodsLightDetail',
    components: {
        [Swipe.name]: Swipe,
        [SwipeItem.name]: SwipeItem,
        Swiper,
        SwiperSlide
    },
    data () {
        return {
            carItems: [ // 车型大全图片
                'https://app.static.public.chetailian.com//1682504847176-icon_ljd.png?imageslim',
                'https://app.static.public.chetailian.com//1682504622609-icon_xrbig.png?imageslim',
                'https://app.static.public.chetailian.com//1682504866217-icon_lals.png?imageslim',
                'https://app.static.public.chetailian.com//1682504725279-icon_xjd.png?imageslim',
                'https://app.static.public.chetailian.com//1682504584927-icon_xstn.png?imageslim',
                'https://app.static.public.chetailian.com//1682504818982-icon_xals.png?imageslim',
                'https://app.static.public.chetailian.com//1682504914057-icon_dfrc.png?imageslim',
                'https://app.static.public.chetailian.com//1682504935281-icon_ftkll.png?imageslim',
                'https://app.static.public.chetailian.com//1682504939907-icon_gqcq.png?imageslim',
                'https://app.static.public.chetailian.com//1682504942287-icon_jldh.png?imageslim',
                'https://app.static.public.chetailian.com//1682504944909-icon_dfxtl.png?imageslim',
                'https://app.static.public.chetailian.com//1682504947637-icon_dzbl.png?imageslim'
            ],
            loopImages: [ // 中间轮播图片
                'https://app.static.public.chetailian.com//1682505220279-picture_slt01.png?imageslim',
                'https://app.static.public.chetailian.com//1682505225553-picture_slt02.png?imageslim',
                'https://app.static.public.chetailian.com//1682505230199-picture_slt03.png?imageslim',
                'https://app.static.public.chetailian.com//1682505236187-picture_slt04.png?imageslim',
                'https://app.static.public.chetailian.com//1682505241477-picture_slt05.png?imageslim',
                'https://app.static.public.chetailian.com//1682505245324-picture_slt06.png?imageslim'
            ],
            swiperOptions: {
                slidesPerView: 3,
                centeredSlides: true,
                loop: true,
                autoplay: true
            }
        }
    },
    methods: {
        // 图片预览
        preview (index) {
            ImagePreview({
                images: this.loopImages,
                startPosition: index
            })
        }
    },
    mounted () {

    }
}
</script>
<style lang="scss" scoped>
#wrapper {
    background-color: #feecde;
}

.detail {
    position: relative;

    &-image {
        width: 100%;
        vertical-align: middle;
    }

    .swiper-image {
        position: relative;
    }
    .item-img{
        width: 161px;
    }

    .swiper {
        width: 325px;
        position: absolute;
        top: 85px;
        left: 50%;
        transform: translateX(-50%);
        height: 224px;
        padding: 36px 0;
        font-size: 0;

        img {
            max-width: 100%;
            vertical-align: middle;
        }

        .swiper-item {
            position: relative;
            z-index: 4;
            transition: all 0.5s ease;
        }

        /deep/ .swiper-slide-active {
            z-index: 5;

            .swiper-item {
                position: relative;
                transform: scale(1.48);

                &::after {
                    content: '';
                    position: absolute;
                    top: 0;
                    left: 0;
                    width: 100%;
                    height: 100%;
                    background: url('~@/assets/vipGoods/106/icon_gx.png') no-repeat;
                    background-size: 100% 100%;
                }
            }
        }
    }

    .loop-image{
        position: relative;
    }
    .my-swipe{
        overflow: hidden;
        width: 325px;
        height: 183px;
        position: absolute;
        top: 89px;
        left: 50%;
        border-radius: 5px;
        transform: translateX(-50%);
    }

    /deep/ .van-swipe__indicator {
        width: 3px;
        height: 3px;
    }

    /deep/ .van-swipe__indicator--active {
        width: 6px;
        border-radius: 2px;
    }

    /deep/ .van-swipe__indicator:not(:last-child) {
        margin-right: 3px;
    }
}
</style>
